module.exports = __webpack_public_path__ + "static/vampire-1dd4c1806225840306f531c827204ca3.jpg";